import styled, { css } from 'styled-components';

export const Container = styled.span`
  color: #fff;

  .MuiButtonBase-root {
    height: 80px;
    width: 94px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: ${(props) => (props.active ? '#0384ac' : '#cbcbcb')};

    ${(props) =>
      props.disabled &&
      css`
        background-color: #cbcbcb80;
      `}
  }

  #icon {
    height: 70%;

    svg,
    span {
      font-size: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-blood-person {
      font-size: 44px;
      height: auto;
    }
  }

  #text {
    height: 30%;
    display: flex;
    align-items: center;

    > .MuiTypography-root {
      font-size: 10px;
      font-weight: 700;
      line-height: normal;
    }
  }
`;
